import { TreeNode } from "./folderTree";

const inFolder = (key: string) => {
  let FOLDER_PATTERN = new RegExp(/\/$/);
  return FOLDER_PATTERN.test(key);
};

function findWhere(array: TreeNode[], value: string) {
  let counter = 0;
  while (counter < array.length && array[counter].name !== value) {
    counter++;
  } // find the index where the id is the as the aValue

  if (counter < array.length) {
    return array[counter];
  } else {
    return false;
  }
}

export function arrangeIntoTree(paths: string[][]) {
  const tree: TreeNode[] = [];

  for (let i = 0; i < paths.length; i++) {
    const path = paths[i];
    let currentLevel = tree;
    for (let j = 0; j < path.length; j++) {
      const part = path[j];

      const existingPath = findWhere(currentLevel, part);

      if (existingPath) {
        currentLevel = existingPath.children;
      } else {
        const currentPath = [...path].splice(0, j + 1);
        const newPart: TreeNode = {
          name: part,
          fullPath: `${currentPath.join("/")}/`,
          children: [],
        };
        currentLevel.push(newPart);
        currentLevel = newPart.children;
      }
    }
  }
  return tree;
}

export const convertContentsToFolderList = (contents: string[]) => {
  //divido tutte le cartelle dai file
  const folders = contents
    .filter(inFolder)
    .map((o) => o.slice(0, -1))
    .map((x) => x.split("/"));

  const tree = arrangeIntoTree(folders);

  return tree;
};
